import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../utilities/props.js";
import { resolveMixin } from "../../styles/mixin.js";
import s from "./Icon.module.css";
const Icon = (props) => {
    const { svg: Component, className, color, size = "1em", autoWidth, attributes } = props;
    const mixinStyles = resolveMixin({ height: size });
    const rootClassName = classNames(s.root, className, mixinStyles.classNames, color && s[`--color-${color}`], autoWidth && s["--auto"]);
    const icon = React.isValidElement(Component) || Component === null ? Component : _jsx(Component, {});
    const style = { ...attributes?.style, ...mixinStyles.variables };
    return (
    // All icons are decorative, a11y attributes should be set for buttons wrapping them
    _jsx("span", { ...attributes, "aria-hidden": "true", className: rootClassName, style: style, children: icon && React.cloneElement(icon, { focusable: false }) }));
};
Icon.displayName = "Icon";
export default Icon;
